import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Options } from 'highcharts'
import * as ChartOptions from '../components/ChartOptions'

interface flowSignalDataOptions {
  flowSignalChartOptions: Options
}

export interface flowSignalReadingDataState {
  isLoading: boolean
  errorMessage: string | null
  flowSignalReadingData: flowSignalDataOptions | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: flowSignalReadingDataState = {
  flowSignalReadingData: {
    flowSignalChartOptions: ChartOptions.getFlameSignalDataOptions()
  },
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const flowSignalDataState = createSlice({
  name: 'flowSignalData',
  initialState,
  reducers: {
    flowSignalDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        flowSignalReadingData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    flowSignalDataUpdateAction: (state, action: PayloadAction<{ data: flowSignalDataOptions, httpStatus: number }>) => {
      return {
        flowSignalReadingData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    flowSignalDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        flowSignalReadingData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  flowSignalDataLoadingAction,
  flowSignalDataUpdateAction,
  flowSignalDataErrorAction
} = flowSignalDataState.actions

export default flowSignalDataState.reducer
